import { appCode } from '@/utils/dictionaries'
import request from '@/utils/request'

/**
 * 【张拉-监测中心】列表
 * @param {object} parameter
 * @property lianghao 梁号
 */
export function listZlsyS (parameter) {
  return request({
    url: `/beam-production-sys/production/ZlsyS/listZlsyS`,
    method: 'get',
    params: parameter
  })
}

/**
 * 【系统管理】--【张拉压浆设备配置】--列表
 * @param {object} parameter
 */
export function getZlyjStationConfigList (parameter) {
  return request({
    url: `/beam-production-sys/production/ZlyjStationConfig/list`,
    method: 'get',
    params: parameter
  })
}

/**
 * 【张拉-监测中心】删除
 * @param {object} parameter
 * @property id 唯一标识
 * */
export function deleteZlsyS (parameter) {
  return request({
    url: `/beam-production-sys/production/ZlsyS/${parameter.id}`,
    method: 'delete'
  })
}

/**
 * 【张拉】查询张拉压浆自定义设置表详情
 * @param {object} parameter
 * */
export function getZlyjCustom (parameter) {
  return request({
    url: `/beam-production-sys/production/ZlyjCustom/getZlyjCustom`,
    method: 'post',
    data: parameter
  })
}
/**
 * 【张拉】修改张拉压浆自定义设置表
 * @param {object} parameter
 * */
export function putZlyjCustom (parameter) {
  return request({
    url: `/beam-production-sys/production/ZlyjCustom/`,
    method: 'put',
    data: parameter
  })
}

/**
 * 【张拉】左侧树
 * @param {object} parameter
 */
export function listZlShebeibianhao (parameter) {
  return request({
    url: `/beam-production-sys/production/ZlsyM/listShebeibianhao`,
    method: 'get',
    params: parameter
  })
}

/**
 * 【压浆】左侧树
 * @param {object} parameter
 */
export function listShebeibianhao (parameter) {
  return request({
    url: `/beam-production-sys/production/YjsyM/listShebeibianhao`,
    method: 'get',
    params: parameter
  })
}

/**
 * 【张拉-监测中心】新增
 * @param {object} parameter
 */
export function saveZlsyM (parameter) {
  return request({
    url: `/beam-production-sys/production/ZlsyM/`,
    method: 'post',
    data: parameter
  })
}
/**
 * 【张拉】恢复
 * @param {object} parameter
 * @property lianghao 梁号
 * @property gsbh 孔号
 * */
export function ZlsyMrecover (parameter) {
  return request({
    url: `/beam-production-sys/production/ZlsyM/recover`,
    method: 'get',
    params: parameter
  })
}

/**
 * 【张拉】查看详细信息-主表
 * @param {object} parameter
 * @property shebeibianhao 设备编号
 * */
export function getZlsyMByShebeibianhao (parameter) {
  return request({
    url: `/beam-production-sys/production/ZlsyM/getZlsyMByShebeibianhao/${parameter.shebeibianhao}`,
    method: 'get'
  })
}

/**
 * 【张拉】查看详细信息-主表
 * @param {object} parameter
 * @property gsbh 孔号
 * @property lianghao 梁号
 * @property shebeibianhao 设备编号
 * */
export function getZlsyMByZlsyMReq (parameter) {
  return request({
    url: `/beam-production-sys/production/ZlsyM/getZlsyMByZlsyMReq`,
    method: 'get',
    params: parameter
  })
}
/**
 * 【张拉】查看详细信息-子表
 * @param {object} parameter
 * @property fguid 设备编号
 * */
export function ZlsySList (parameter) {
  return request({
    url: `/beam-production-sys/production/ZlsyS/${parameter.fguid}`,
    method: 'get'
  })
}
/**
 * 【张拉】修改
 * @param {object} parameter
 * */
export function updateZlData (parameter) {
  return request({
    url: `/beam-production-sys/production/ZlsyM/updateZlData/`,
    method: 'put',
    data: parameter
  })
}
/**
 * 【监测中心】列表
 * @param {object} parameter
 * @property lianghao 梁号
 */
export function listYjsyS (parameter) {
  return request({
    url: `/beam-production-sys/production/YjsyS/listYjsyS`,
    method: 'get',
    params: parameter
  })
}
/**
 * 【压浆-监测中心】新增
 * @param {object} parameter
 */
export function saveYjInfo (parameter) {
  return request({
    url: `/beam-production-sys/production/YjsyM/saveYjInfo`,
    method: 'post',
    data: parameter
  })
}
/**
 * 【监测中心】删除压浆数据
 * @param {object} parameter
 * @property lianghao 梁号
 */
export function deleteYjsyS (parameter) {
  return request({
    url: `/beam-production-sys/production/YjsyM/${parameter.id}`,
    method: 'delete',
    data: parameter
  })
}
/**
 * 【压浆】查看详细信息
 * @param {object} parameter
 * @property lianghao 梁号
 */
export function getYjsyMByLianghao (parameter) {
  return request({
    url: `/beam-production-sys/production/YjsyM/getYjsyMByLianghao/${encodeURIComponent(parameter.lianghao)}`,
    method: 'get'
  })
}
/**
 * 【压浆】通过id查看详细信息
 * @param {object} parameter
 * @property lianghao 梁号
 */
export function getYjsyMById (parameter) {
  return request({
    url: `/beam-production-sys/production/YjsyM/getYjsyMById/${parameter.id}`,
    method: 'get'
  })
}
/**
 * 【压浆】查看详细信息
 * @param {object} parameter
 * @property shebeibianhao 设备编号
 * */
export function getYjsyMByShebeibianhao (parameter) {
  return request({
    url: `/beam-production-sys/production/YjsyM/getYjsyMByShebeibianhao/${parameter.shebeibianhao}`,
    method: 'get'
  })
}

/**
 * 获取梁型列表
 * @param {object} parameter
 * @property {String} beamModelName	梁型名称
 */
export function getBeamModelList (parameter) {
  return request({
    url: '/beam-production-sys/production/BeamModel/list',
    method: 'get',
    params: parameter
  })
}
/**
 * 【梁型配置】--查询梁型配置表列表
 * @param {object} parameter
 */
export function listBeamMoldConfig (parameter) {
  return request({
    url: `/beam-production-sys/production/BeamMoldConfig/listBeamMoldConfig`,
    method: 'get',
    params: Object.assign({ appCode }, parameter) // 所有传参都加上appCode
  })
}
/**
 * 【压浆】修改
 * @param {object} parameter
 */
export function updateYjsyS (parameter) {
  return request({
    // url: `/beam/YjsyS/`,
    url: `/beam-production-sys/production/YjsyM/`,
    method: 'put',
    data: parameter
  })
}
/**
 * 【监测中心】操作记录
 * @param {object} parameter
 * @property startTime 开始时间
 * @property endTime 结束时间
 * @property search 操作人
 * @property type 操作类型 1张拉 2压浆
 *  */
export function OperationRecord (parameter) {
  return request({
    url: `/beam-production-sys/production/OperationRecord/list`,
    method: 'get',
    params: parameter
  })
}
/**
 * 导出
 * @param {object} parameter
 * @property {number[]} ids ids
 * @property {number} type 类型 1打卡记录
 * @property {object} workerAttendanceTemp 打卡记录请求
 */
export function exportExcel (parameter) {
  return request({
    url: '/beam-production-sys/production/exportFile/exportExcel',
    method: 'post',
    data: parameter
  })
}
/**
 * 【压浆】恢复
 * @param {object} parameter
 * @property lianghao 梁号
 */
export function beamRecover (parameter) {
  return request({
    url: `/beam-production-sys/production/YjsyM/recover/${parameter.lianghao}`,
    method: 'get',
    params: parameter
  })
}
/**
 * 【张拉监测】查询张拉预警配置表列表
 * @param {object} parameter
 */
export function listZlsyWarn (parameter) {
  return request({
    url: `/beam-production-sys/production/ZlsyWarn/listZlsyWarn`,
    method: 'get',
    params: parameter
  })
}
/**
 * 【张拉监测】保存张拉预警配置表
 * @param {object} parameter
 */
export function saveZlsyWarn (parameter) {
  return request({
    url: `/beam-production-sys/production/ZlsyWarn/saveZlsyWarn`,
    method: 'post',
    data: parameter
  })
}
/**
 * 【压浆监测】查询压浆预警配置表列表
 * @param {object} parameter
 */
export function listYjsyWarn (parameter) {
  return request({
    url: `/beam-production-sys/production/YjsyWarn/listYjsyWarn`,
    method: 'get',
    params: parameter
  })
}
/**
 * 【压浆监测】保存压浆预警配置表
 * @param {object} parameter
 */
export function saveYjsyWarn (parameter) {
  return request({
    url: `/beam-production-sys/production/YjsyWarn/saveYjsyWarn`,
    method: 'post',
    data: parameter
  })
}
